import { nodeConnectionRules } from "../configs/nodeConnectionRules";
/**
 * Check if source -> target is permitted
 * under the nodeConnectionRules plus max in/out constraints.
 */
export function isConnectionAllowed(sourceNode, targetNode, edges) {
    if (!sourceNode || !targetNode) {
        return { allowed: false, reason: "One or both nodes are missing." };
    }
    if (!sourceNode.type || !targetNode.type) {
        return { allowed: false, reason: "One or both nodes have an undefined type." };
    }
    var sourceRules = nodeConnectionRules[sourceNode.type];
    var targetRules = nodeConnectionRules[targetNode.type];
    // Check if the node type exists in the rules
    if (!sourceRules) {
        return { allowed: false, reason: "Invalid source node type: ".concat(sourceNode.type, ".") };
    }
    if (!targetRules) {
        return { allowed: false, reason: "Invalid target node type: ".concat(targetNode.type, ".") };
    }
    // 1) Check if the target node type is in the source node's allowedOutgoingNodes
    if (!sourceRules.allowedOutgoingNodes.includes(targetNode.type)) {
        return {
            allowed: false,
            reason: "".concat(sourceNode.type, " is not allowed to connect to ").concat(targetNode.type, "."),
        };
    }
    // 2) Check if the source node type is in the target node's allowedIncomingNodes
    if (!targetRules.allowedIncomingNodes.includes(sourceNode.type)) {
        return {
            allowed: false,
            reason: "".concat(targetNode.type, " cannot accept a connection from ").concat(sourceNode.type, "."),
        };
    }
    // 3) Check maxIncoming limit for the target node
    var existingIncomingEdges = edges.filter(function (e) { return e.target === targetNode.id; }).length;
    if (existingIncomingEdges >= targetRules.maxIncoming) {
        return {
            allowed: false,
            reason: "".concat(targetNode.type, " can have a maximum of ").concat(targetRules.maxIncoming, " incoming connection(s)."),
        };
    }
    // 4) If maxOutgoingPerType is defined, use it as the primary rule
    if (sourceRules.maxOutgoingPerType) {
        var maxOutgoingForType = sourceRules.maxOutgoingPerType[targetNode.type];
        if (maxOutgoingForType !== undefined) {
            // Check if there are any existing connections to different node types
            var existingOutgoingEdges = edges.filter(function (e) { return e.source === sourceNode.id; });
            var isString_1 = function (value) { return typeof value === 'string'; };
            var hasDifferentTypeConnections = existingOutgoingEdges.some(function (e) { return isString_1(e.target) && targetNode.type && !e.target.startsWith(targetNode.type); });
            if (hasDifferentTypeConnections) {
                return {
                    allowed: false,
                    reason: "".concat(sourceNode.type, " cannot mix connections to different node types when maxOutgoingPerType is defined."),
                };
            }
            // Count existing connections to the same type
            var existingOutgoingEdgesOfType = existingOutgoingEdges.filter(function (e) { return isString_1(e.target) && targetNode.type && e.target.startsWith(targetNode.type); }).length;
            if (existingOutgoingEdgesOfType >= maxOutgoingForType) {
                return {
                    allowed: false,
                    reason: "".concat(sourceNode.type, " can have a maximum of ").concat(maxOutgoingForType, " outgoing connection(s) to ").concat(targetNode.type, "."),
                };
            }
        }
    }
    else {
        // 5) Only check maxOutgoing if maxOutgoingPerType is not defined
        var existingOutgoingEdges = edges.filter(function (e) { return e.source === sourceNode.id; }).length;
        if (existingOutgoingEdges >= sourceRules.maxOutgoing) {
            return {
                allowed: false,
                reason: "".concat(sourceNode.type, " can have a maximum of ").concat(sourceRules.maxOutgoing, " outgoing connection(s)."),
            };
        }
    }
    return { allowed: true, reason: "Connection allowed." };
}
